import { UserInterface } from "@/ts/interfaces/Parent/UserInterface";

export const getFileUploaderFileTypes = (apiFileTypes: string[]): string[] => {
    if (!apiFileTypes || apiFileTypes.length === 0) {
        return [];
    }

    const uniqueFileTypes: string[] = Array.from(
        new Set(apiFileTypes.map(type => type.trim().toLowerCase()))
    );

    const filteredFileTypes = uniqueFileTypes
        .map(type => {
            switch (type) {
                case "pdf":
                    return "PDF";
                case "doc":
                    return "DOC";
                case "docx":
                    return "DOCX";
                case "xls":
                    return "XLS";
                case "xlsx":
                    return "XLSX";
                case "jpg":
                    return "JPG";
                case "png":
                    return "PNG";
                case "svg":
                    return "SVG";
                case "mp4":
                    return "MP4";
                default:
                    return null;
            }
        })
        .filter(type => type !== null);
    return filteredFileTypes;
};

export const isNonAssessedByGrade = (
    gradeCode: string,
    auth: UserInterface
): boolean => {
    const numericGradeCode = Number(gradeCode);
    if (isNaN(numericGradeCode)) {
        console.warn(`Invalid gradeCode: ${gradeCode}`);
        return false;
    }
    const getAllActiveLicense = auth?.active_licenses;
    const plan = getAllActiveLicense.find(
        p => p.grade?.grade_code === numericGradeCode
    );
    return plan?.is_non_assessed ?? false;
};
